angular.module('bribac.views.uploadSubjects', [
    'ngRoute',
    'bribac.translations',
    'bribac.values',
    'bribac.entities.kinds',
    'bribac.entities.subjectFactory',
    'bribac.services.routeAuth',
    'bribac.components.subjectEditor',
    'bribac.components.subjectDetails',
    'bribac.components.subjectUpload'
])
    .config(function ($routeProvider) {
        $routeProvider.when('/upload/subjects', {
            templateUrl: 'upload-subjects-view.html',
            controller: 'UploadSubjectsViewCtrl',
            controllerAs: '$ctrl',
            resolve: {
                access: function (routeAuth) {
                    return routeAuth.requireAuth()
                }
            }
        });
    })
    .controller('UploadSubjectsViewCtrl', function (
        $location,
        KINDS,
        subjectFactory,
        state
    ) {
        var $ctrl = this;

        $ctrl.savedEntities = [];
        $ctrl.errors = null;
        $ctrl.successMessage = null;

        $ctrl.handleSubjectsUploaded = function(params) {
            $ctrl.errors = null;
            $ctrl.successMessage = null;

            if (params.response.data && params.response.data.errors && params.response.data.errors.length) {
                $ctrl.errors = params.response.data.errors;
                return;
            }

            $ctrl.successMessage = "Subjects saved successfully";

            params.subjects.forEach(function(subject) {
                const entity = subjectFactory({
                    id: subject.id,
                    firstName: subject.firstName,
                    lastName: subject.lastName,
                    ssn: subject.ssn,
                    address: subject.address,
                    postalCode: subject.postalCode,
                    phone: subject.phone,
                    city: subject.city,
                    email: subject.email,
                    locale: state.currentAgent.locale
                });
                $ctrl.savedEntities.push(entity);
            });
        };
    });